import { FC, ReactNode } from 'react';
import { Alert } from '@silverfort/sf-components';

interface ReportBaseProps {
    headerTitle: string;
    headerDescription: string;
    footerContent: ReactNode;
}

const ReportBase: FC<ReportBaseProps> = ({ headerTitle, headerDescription, children, footerContent }) => {
    return (
        <>
            <div className="flex flex-col justify-between p-6 my-4 bg-sf-gray-0 rounded-lg w-80">
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-2 border-b pb-[5px] border-sf-gray-100">
                        <span className="text-14 font-medium text-sf-dark-500">{headerTitle}</span>
                        <span className="text-13 font-normal text-sf-gray-400">{headerDescription}</span>
                    </div>
                    <div className="flex flex-col gap-6 overflow-auto -mr-3 pr-3 h-[calc(100vh-355px)]">{children}</div>
                </div>
                <div className="flex justify-end mt-6">{footerContent}</div>
            </div>
            <Alert />
        </>
    );
};

export default ReportBase;
